module.exports = __webpack_public_path__ + "static/media/default-error.f8c411a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/default-error.svg
// module id = 2387
// module chunks = 0